export default { 
    //中文
    home: {
        subsidiary: '下属子公司',
       
       
    }
}
